@if (labelKey(); as key) {
  <span
    class="dpia-risk-badge"
    [class.dpia-risk-badge--success]="tone() === 'success'"
    [class.dpia-risk-badge--warning]="tone() === 'warning'"
    [class.dpia-risk-badge--error]="tone() === 'error'"
  >
    {{ key | transloco }}
  </span>
}
